<template>
    <main class="play-back">
        <div class="play-back-list-content-container">
            <hk-notice></hk-notice>
            <div class="play-back-list-container">
                <div class="replay-tab">
                    <ul class="replay-tab-container flex">
                        <li
                            v-for="(item, index) in tabs"
                            :key="index"
                            :class="[
                                { active: tabActive === item.id },
                                'replay-tab-container-item'
                            ]"
                            @click="changeTab(index, item)"
                        >
                            {{ item.name }}
                        </li>
                    </ul>
                    <span
                        class="active-border"
                        :style="{ transform: `translate(${disCount * 74}px)` }"
                    ></span>
                </div>
                <div class="conditions flex flex-between flex-vertical-center">
                    <div class="search-container">
                        <input
                            v-model="search"
                            type="text"
                            placeholder="请输入课程名称"
                            class="search"
                        />
                        <span class="search-btn" @click="handleSearch">搜索</span>
                    </div>
                    <div class="sort-way flex flex-vertical-center">
                        <label class="way-label">排序方式</label>
                        <el-radio-group v-model="radio" @change="changeSort">
                            <el-radio label="asc">开课时间正序</el-radio>
                            <el-radio label="desc">开课时间倒序</el-radio>
                        </el-radio-group>
                        <el-checkbox v-model="checked" @change="changeState"
                            >只显示未做作业</el-checkbox
                        >
                    </div>
                </div>
                <div
                    v-if="playBackList.length === 0 || playBackList === ''"
                    class="no-lesson flex flex-column flex-vertical-center flex-center"
                >
                    <img src="@images/base/no-lesson.png" class="no-lesson-img" alt="" />
                    <p class="no-lesson-text">暂无课程，老师正在加急上传中</p>
                </div>
                <div
                    v-for="(item, index) in playBackListData"
                    v-else
                    :key="index"
                    class="month-list"
                >
                    <play-back-list :listData="item" :title="index"></play-back-list>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import HkNotice from '@components/HkNotice';
import PlayBackList from '@components/playBackList/PlayBackList';
import moment from '@plugins/_moment';
import { getSubjectList, getReplayList } from '@/api/replayList';
import { getDocumentTop, getWindowHeight, getScrollHeight } from '@helpers/scroll-event';
import { debounce } from 'lodash';

export default {
    name: 'ReplayList',
    components: {
        // HkScreen,
        HkNotice,
        PlayBackList
    },
    data() {
        return {
            playBackList: [],
            tabs: [{ id: 0, name: '全部' }],
            tabActive: 0,
            disCount: 0,
            search: '',
            radio: 'desc',
            checked: false,
            page: 1,
            debounceGetReplayData: null,
            listCount: 0,
            loading: false
        };
    },
    computed: {
        playBackListData() {
            const { playBackList } = this;
            const data = {};
            playBackList.forEach((item) => {
                const showTime = moment(item.show_time);
                const key = showTime.format('yyyy年MM月');
                const value = data[key];
                if (!value) {
                    data[key] = [];
                }
                data[key].push(item);
            });
            return data;
        }
    },
    created() {
        this.getSubjectData();
        this.debounceGetReplayData = debounce(this.getReplayListData.bind(this), 300);
    },
    mounted() {
        this.bindScroll();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.loadNextPage);
    },
    methods: {
        changeTab(index, item) {
            this.disCount = index;
            this.tabActive = item.id;
            this.page = 1;
            this.playBackList = [];
            this.getReplayListData();
        },
        changeSort(e) {
            this.page = 1;
            this.playBackList = [];
            this.getReplayListData();
        },
        changeState(e) {
            this.page = 1;
            this.playBackList = [];
            this.getReplayListData();
        },
        handleSearch() {
            this.page = 1;
            this.playBackList = [];
            this.getReplayListData();
        },
        getSubjectData() {
            getSubjectList().then((res) => {
                console.log(res);
                if (res.code === 0) {
                    const subjectData = res.data;
                    for (let key in subjectData) {
                        if (subjectData.hasOwnProperty(key)) {
                            let data = {};
                            data.id = key;
                            data.name = subjectData[key];
                            this.tabs.push(data);
                            data = {};
                        }
                    }
                    this.tabActive = this.tabs[0].id;
                    this.getReplayListData();
                }
            });
        },
        bindScroll() {
            window.addEventListener('scroll', this.loadNextPage);
        },
        getReplayListData() {
            if (this.loading || (this.playBackList.length >= this.listCount && this.page > 1)) {
                return;
            }
            const param = {
                sort: this.radio,
                undo: this.checked ? 1 : 0,
                subject_id: this.tabActive,
                name: this.search,
                page: this.page
            };
            this.loading = true;
            getReplayList(param)
                .then((res) => {
                    this.listCount = res.count;
                    this.playBackList.push(...res.data);
                    this.page++;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        loadNextPage(e) {
            let scrollDis = getDocumentTop();
            let clientHeight = getWindowHeight();
            let documentHeight = getScrollHeight();
            if (scrollDis + clientHeight >= documentHeight - 120) {
                this.debounceGetReplayData();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.play-back {
    background: #f7f6f6;
    .play-back-list-content-container {
        border-radius: 0px 24px 0px 0px;
        background-color: #fff;
        .play-back-list-container {
            box-sizing: border-box;
            width: 960px;
            padding: 77px 0 23px 40px;
            position: relative;
            .replay-tab {
                position: absolute;
                top: 23px;
                left: 0;
                width: 100%;
                .replay-tab-container {
                    padding-bottom: 15px;
                    border-bottom: 1px solid #e5e5e5;
                    padding-left: 40px;
                    width: 100%;
                    box-sizing: border-box;
                    // margin-bottom: 20px;
                    &-item {
                        width: 70px;
                        text-align: center;
                        font-size: 16px;
                        font-family: PingFangSC;
                        font-weight: bold;
                        color: #333;
                        cursor: pointer;
                        user-select: none;
                    }
                    &-item:not(:last-child) {
                        margin-right: 4px;
                    }
                }
                .active-border {
                    display: block;
                    width: 70px;
                    height: 3px;
                    background-color: #7d0f83;
                    position: absolute;
                    bottom: -1px;
                    left: 40px;
                    transition: transform 0.3s;
                }
            }
            .conditions {
                margin-bottom: 22px;
                padding-right: 20px;
                .search-container {
                    position: relative;
                    .search {
                        box-sizing: border-box;
                        width: 320px;
                        height: 36px;
                        background: url('~@images/base/search-icon.png') no-repeat 11px center
                            #f0f0f0;
                        border-radius: 18px;
                        padding: 0 90px 0 36px;
                        border: none;
                        outline: none;
                        font-size: 14px;
                        color: #999;
                    }
                    .search-btn {
                        position: absolute;
                        top: 0;
                        right: 0;
                        display: block;
                        width: 80px;
                        height: 36px;
                        text-align: center;
                        line-height: 36px;
                        border-radius: 18px;
                        color: #fff;
                        background-color: #7d0f83;
                        font-size: 14px;
                        cursor: pointer;
                        user-select: none;
                    }
                }
                .sort-way {
                    .way-label {
                        margin-right: 19px;
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #333;
                    }
                    &::v-deep {
                        .el-radio-group {
                            display: flex;
                            align-items: center;
                            padding-right: 20px;
                            border-right: 1px solid #b8b8b8;
                            margin-right: 20px;
                        }
                        .el-radio {
                            display: flex;
                            align-items: center;
                            color: #333;
                        }
                        .el-radio__inner {
                            border: none;
                            background: #cfcccf;
                        }
                        .el-radio__input.is-checked .el-radio__inner {
                            background: #7e0e82;
                        }
                        .el-radio__input.is-checked + .el-radio__label,
                        .el-checkbox__input.is-checked + .el-checkbox__label {
                            color: #333;
                        }
                        .el-checkbox__inner {
                            border: none;
                            background: #cfcccf;
                        }
                        .el-checkbox__input.is-checked .el-checkbox__inner {
                            background: #7e0e82;
                        }
                        .el-checkbox__inner::after {
                            content: '';
                            position: absolute;
                            left: 5px;
                            top: 2.5px;
                            transition: transform 0.15s ease-in;
                        }
                    }
                }
            }
            .no-lesson {
                width: 100%;
                margin-top: 126px;
                &-text {
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #333;
                }
            }
        }
    }
}
</style>
